// extracted by mini-css-extract-plugin
export default {"root":"jq5Ii68F","button":"jJRQ7lHA"};